export default "__VITE_ASSET__1mHNElpY__"